import React from "react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { Container } from "./styles";

const DateSelector = ({ label, value, setValue, error, ...props }) => {
  const [currentError, setCurrentError] = React.useState("");

  function handleDate(inputValue) {
    if (!inputValue) {
      setCurrentError("Data inválida");
      return;
    }
    const newDate = new Date(inputValue);
    setCurrentError("");

    setValue(newDate);
  }

  return (
    <Container>
      <label>{label}</label>
      <SemanticDatepicker
        value={value}
        onChange={(e, data) => handleDate(data.value)}
        format="DD/MM/YYYY"
        placeholder="__/__/____"
        onFocus={() => setCurrentError("")}
        {...props}
      />
      {error && <p>{error}</p>}
      {currentError && <p>{currentError}</p>}
    </Container>
  );
};

export default DateSelector;
